/** Hasura roles whose permissions are for the managed app, not the learner account. */
const STAFF_ACCOUNT_ROLES = new Set(["tutor", "manager", "owner"]);

export const LEARNER_ACCOUNT_GRAPHQL_PATH = "/api/account/graphql/";

export function isStaffAccountRole(role: string | null | undefined) {
  return Boolean(role && STAFF_ACCOUNT_ROLES.has(role.toLowerCase()));
}

function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const part = token.split(".")[1];
  if (!part) return null;

  try {
    const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const decoded =
      typeof atob === "function"
        ? atob(padded)
        : Buffer.from(padded, "base64").toString("utf8");
    return JSON.parse(decoded) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function hasuraClaimsFromToken(token: string): Record<string, string> | null {
  const payload = decodeJwtPayload(token);
  const raw = payload?.["https://hasura.io/jwt/claims"];
  if (!raw) return null;

  try {
    const claims = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!claims || typeof claims !== "object") return null;
    return claims as Record<string, string>;
  } catch {
    return null;
  }
}

export function isStaffAccountToken(token: string) {
  const claims = hasuraClaimsFromToken(token);
  const role = claims?.["x-hasura-role"] || claims?.["x-hasura-default-role"];
  return isStaffAccountRole(role);
}
